module.exports = __webpack_public_path__ + "img/17.3af62307.jpg";